import React from "react";
import { StyleSheet, Text, TouchableOpacity } from "react-native";

import colors from "../config/colors";

function AppButton({ title, txtStyle = '', btnStyle = '', onPress, color = "primary" }) {
  return (
    <TouchableOpacity
      style={btnStyle === '' ? [styles.button, { backgroundColor: colors[color] }] : [btnStyle, { backgroundColor: colors[color] }]}
      onPress={onPress}
    >
      <Text style={txtStyle === '' ? styles.text : txtStyle}>{title}</Text>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  button: {
    backgroundColor: colors.primary,
    borderRadius: 25,
    justifyContent: "center",
    alignItems: "center",
    padding: 15,
    width: "100%",
    marginVertical: "0.2%",
  },
  text: {
    color: colors.white,
    fontSize: 18,
    textTransform: "uppercase",
    fontWeight: "bold",
  },
});

export default AppButton;
